import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Paper,
  Card,
  CardContent,
  Grid,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Chip,
  Alert,
  AlertTitle,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Avatar,
  Menu,
  Tooltip,
  Fab
} from '@mui/material';
import {
  Add as AddIcon,
  LocationOn as LocationOnIcon,
  Business as BusinessIcon,
  Public as PublicIcon,
  Map as MapIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  MoreVert as MoreVertIcon,
  ExpandMore as ExpandMoreIcon,
  Place as PlaceIcon,
  Store as StoreIcon,
  Analytics as AnalyticsIcon,
  Visibility as VisibilityIcon,
  MyLocation as MyLocationIcon,
  TrendingUp as TrendingUpIcon
} from '@mui/icons-material';

const BazarManager = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogType, setDialogType] = useState(''); // 'district', 'upazilla', 'bazar'
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [selectedUpazilla, setSelectedUpazilla] = useState('');
  const [actionMenuAnchor, setActionMenuAnchor] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  // Mock data with hierarchical structure
  const [locations, setLocations] = useState({
    districts: [
      {
        id: 1,
        name: 'ঢাকা',
        nameEn: 'Dhaka',
        latitude: 23.8103,
        longitude: 90.4125,
        population: 9000000,
        area: 1463.60,
        totalUpazillas: 2,
        totalBazars: 8,
        status: 'সক্রিয়'
      },
      {
        id: 2,
        name: 'চট্টগ্রাম',
        nameEn: 'Chittagong',
        latitude: 22.3569,
        longitude: 91.7832,
        population: 2592439,
        area: 5282.92,
        totalUpazillas: 1,
        totalBazars: 3,
        status: 'সক্রিয়'
      }
    ],
    upazillas: [
      {
        id: 1,
        name: 'ধানমন্ডি',
        nameEn: 'Dhanmondi',
        districtId: 1,
        latitude: 23.7461,
        longitude: 90.3742,
        population: 350000,
        area: 8.3,
        totalBazars: 5,
        status: 'সক্রিয়'
      },
      {
        id: 2,
        name: 'গুলশান',
        nameEn: 'Gulshan',
        districtId: 1,
        latitude: 23.7925,
        longitude: 90.4078,
        population: 280000,
        area: 15.2,
        totalBazars: 3,
        status: 'সক্রিয়'
      },
      {
        id: 3,
        name: 'পাহাড়তলী',
        nameEn: 'Pahartali',
        districtId: 2,
        latitude: 22.3617,
        longitude: 91.8103,
        population: 125000,
        area: 22.5,
        totalBazars: 3,
        status: 'সক্রিয়'
      }
    ],
    bazars: [
      {
        id: 1,
        name: 'ধানমন্ডি কেন্দ্রীয় বাজার',
        nameEn: 'Dhanmondi Central Market',
        districtId: 1,
        upazillaId: 1,
        latitude: 23.7461,
        longitude: 90.3742,
        address: 'ধানমন্ডি রোড ২৭, ঢাকা',
        totalStores: 45,
        totalVendors: 38,
        establishedYear: 1995,
        area: 2.5,
        operatingHours: '৬:০০ - ২২:০০',
        status: 'সক্রিয়',
        revenue: 125000
      },
      {
        id: 2,
        name: 'নিউ মার্কেট',
        nameEn: 'New Market',
        districtId: 1,
        upazillaId: 1,
        latitude: 23.7279,
        longitude: 90.3917,
        address: 'নিউ মার্কেট, আজিমপুর, ঢাকা',
        totalStores: 120,
        totalVendors: 95,
        establishedYear: 1954,
        area: 8.2,
        operatingHours: '৮:০০ - ২১:০০',
        status: 'সক্রিয়',
        revenue: 280000
      },
      {
        id: 3,
        name: 'গুলশান ২ বাজার',
        nameEn: 'Gulshan 2 Market',
        districtId: 1,
        upazillaId: 2,
        latitude: 23.7925,
        longitude: 90.4078,
        address: 'গুলশান ২, ঢাকা',
        totalStores: 35,
        totalVendors: 28,
        establishedYear: 2005,
        area: 1.8,
        operatingHours: '৭:০০ - ২২:০০',
        status: 'সক্রিয়',
        revenue: 95000
      }
    ]
  });

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const handleAddNew = (type) => {
    setDialogType(type);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setDialogType('');
    setSelectedDistrict('');
    setSelectedUpazilla('');
  };

  const handleActionMenuOpen = (event, item, type) => {
    setActionMenuAnchor(event.currentTarget);
    setSelectedItem({ ...item, type });
  };

  const handleActionMenuClose = () => {
    setActionMenuAnchor(null);
    setSelectedItem(null);
  };

  const getDistrictName = (districtId) => {
    const district = locations.districts.find(d => d.id === districtId);
    return district ? district.name : '';
  };

  const getUpazillaName = (upazillaId) => {
    const upazilla = locations.upazillas.find(u => u.id === upazillaId);
    return upazilla ? upazilla.name : '';
  };

  const totalStats = {
    districts: locations.districts.length,
    upazillas: locations.upazillas.length,
    bazars: locations.bazars.length,
    totalStores: locations.bazars.reduce((sum, bazar) => sum + bazar.totalStores, 0),
    totalRevenue: locations.bazars.reduce((sum, bazar) => sum + bazar.revenue, 0)
  };

  const renderTabContent = () => {
    switch (currentTab) {
      case 0: // Overview
        return (
          <Box>
            {/* Statistics Cards */}
            <Grid container spacing={3} sx={{ mb: 4 }}>
              <Grid item xs={12} sm={6} md={2.4}>
                <Card sx={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
                  <CardContent sx={{ p: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.3)' }}>
                        <PublicIcon />
                      </Avatar>
                      <Box>
                        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>{totalStats.districts}</Typography>
                        <Typography variant="body2">জেলা</Typography>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
              
              <Grid item xs={12} sm={6} md={2.4}>
                <Card sx={{ background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', color: 'white' }}>
                  <CardContent sx={{ p: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.3)' }}>
                        <BusinessIcon />
                      </Avatar>
                      <Box>
                        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>{totalStats.upazillas}</Typography>
                        <Typography variant="body2">উপজেলা</Typography>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
              
              <Grid item xs={12} sm={6} md={2.4}>
                <Card sx={{ background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)', color: 'white' }}>
                  <CardContent sx={{ p: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.3)' }}>
                        <StoreIcon />
                      </Avatar>
                      <Box>
                        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>{totalStats.bazars}</Typography>
                        <Typography variant="body2">বাজার</Typography>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
              
              <Grid item xs={12} sm={6} md={2.4}>
                <Card sx={{ background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', color: 'white' }}>
                  <CardContent sx={{ p: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.3)' }}>
                        <PlaceIcon />
                      </Avatar>
                      <Box>
                        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>{totalStats.totalStores}</Typography>
                        <Typography variant="body2">মোট দোকান</Typography>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
              
              <Grid item xs={12} sm={6} md={2.4}>
                <Card sx={{ background: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)', color: '#333' }}>
                  <CardContent sx={{ p: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.7)' }}>
                        <TrendingUpIcon />
                      </Avatar>
                      <Box>
                        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>৳{(totalStats.totalRevenue/1000).toFixed(0)}K</Typography>
                        <Typography variant="body2">মাসিক আয়</Typography>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            {/* Hierarchical Structure Display */}
            <Paper sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
                অঞ্চলভিত্তিক কাঠামো
              </Typography>
              {locations.districts.map((district) => (
                <Accordion key={district.id} sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                      <LocationOnIcon color="primary" />
                      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                        {district.name} জেলা
                      </Typography>
                      <Chip label={`${district.totalUpazillas} উপজেলা`} size="small" />
                      <Chip label={`${district.totalBazars} বাজার`} size="small" color="primary" />
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails>
                    {locations.upazillas
                      .filter(upazilla => upazilla.districtId === district.id)
                      .map((upazilla) => (
                        <Box key={upazilla.id} sx={{ ml: 4, mb: 2 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
                            <BusinessIcon color="secondary" />
                            <Typography variant="subtitle2" sx={{ fontWeight: 500 }}>
                              {upazilla.name} উপজেলা
                            </Typography>
                            <Chip label={`${upazilla.totalBazars} বাজার`} size="small" variant="outlined" />
                          </Box>
                          {locations.bazars
                            .filter(bazar => bazar.upazillaId === upazilla.id)
                            .map((bazar) => (
                              <Box key={bazar.id} sx={{ ml: 4, mb: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
                                <StoreIcon sx={{ fontSize: 20, color: 'success.main' }} />
                                <Typography variant="body2">
                                  {bazar.name} ({bazar.totalStores} দোকান)
                                </Typography>
                                <Chip 
                                  label={bazar.status} 
                                  size="small" 
                                  color="success" 
                                  variant="outlined" 
                                />
                              </Box>
                            ))}
                        </Box>
                      ))}
                  </AccordionDetails>
                </Accordion>
              ))}
            </Paper>
          </Box>
        );

      case 1: // Districts
        return (
          <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>জেলা পরিচালনা</Typography>
              <Button 
                variant="contained" 
                startIcon={<AddIcon />}
                onClick={() => handleAddNew('district')}
              >
                নতুন জেলা যোগ করুন
              </Button>
            </Box>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>জেলার নাম</TableCell>
                    <TableCell>অবস্থান</TableCell>
                    <TableCell align="center">উপজেলা</TableCell>
                    <TableCell align="center">বাজার</TableCell>
                    <TableCell align="center">জনসংখ্যা</TableCell>
                    <TableCell align="center">এলাকা (বর্গ কিমি)</TableCell>
                    <TableCell align="center">অবস্থা</TableCell>
                    <TableCell align="center">অ্যাকশন</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {locations.districts.map((district) => (
                    <TableRow key={district.id}>
                      <TableCell>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                          {district.name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {district.nameEn}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {district.latitude.toFixed(4)}, {district.longitude.toFixed(4)}
                        </Typography>
                      </TableCell>
                      <TableCell align="center">{district.totalUpazillas}</TableCell>
                      <TableCell align="center">{district.totalBazars}</TableCell>
                      <TableCell align="center">{(district.population/1000000).toFixed(1)}M</TableCell>
                      <TableCell align="center">{district.area}</TableCell>
                      <TableCell align="center">
                        <Chip label={district.status} color="success" size="small" />
                      </TableCell>
                      <TableCell align="center">
                        <IconButton onClick={(e) => handleActionMenuOpen(e, district, 'district')}>
                          <MoreVertIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        );

      case 2: // Upazillas
        return (
          <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>উপজেলা পরিচালনা</Typography>
              <Button 
                variant="contained" 
                startIcon={<AddIcon />}
                onClick={() => handleAddNew('upazilla')}
              >
                নতুন উপজেলা যোগ করুন
              </Button>
            </Box>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>উপজেলার নাম</TableCell>
                    <TableCell>জেলা</TableCell>
                    <TableCell>অবস্থান</TableCell>
                    <TableCell align="center">বাজার</TableCell>
                    <TableCell align="center">জনসংখ্যা</TableCell>
                    <TableCell align="center">এলাকা (বর্গ কিমি)</TableCell>
                    <TableCell align="center">অবস্থা</TableCell>
                    <TableCell align="center">অ্যাকশন</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {locations.upazillas.map((upazilla) => (
                    <TableRow key={upazilla.id}>
                      <TableCell>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                          {upazilla.name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {upazilla.nameEn}
                        </Typography>
                      </TableCell>
                      <TableCell>{getDistrictName(upazilla.districtId)}</TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {upazilla.latitude.toFixed(4)}, {upazilla.longitude.toFixed(4)}
                        </Typography>
                      </TableCell>
                      <TableCell align="center">{upazilla.totalBazars}</TableCell>
                      <TableCell align="center">{(upazilla.population/1000).toFixed(0)}K</TableCell>
                      <TableCell align="center">{upazilla.area}</TableCell>
                      <TableCell align="center">
                        <Chip label={upazilla.status} color="success" size="small" />
                      </TableCell>
                      <TableCell align="center">
                        <IconButton onClick={(e) => handleActionMenuOpen(e, upazilla, 'upazilla')}>
                          <MoreVertIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        );

      case 3: // Bazars
        return (
          <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>বাজার পরিচালনা</Typography>
              <Button 
                variant="contained" 
                startIcon={<AddIcon />}
                onClick={() => handleAddNew('bazar')}
              >
                নতুন বাজার যোগ করুন
              </Button>
            </Box>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>বাজারের নাম</TableCell>
                    <TableCell>অবস্থান</TableCell>
                    <TableCell>ঠিকানা</TableCell>
                    <TableCell align="center">দোকান</TableCell>
                    <TableCell align="center">বিক্রেতা</TableCell>
                    <TableCell align="center">মাসিক আয়</TableCell>
                    <TableCell align="center">অবস্থা</TableCell>
                    <TableCell align="center">অ্যাকশন</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {locations.bazars.map((bazar) => (
                    <TableRow key={bazar.id}>
                      <TableCell>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                          {bazar.name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {getDistrictName(bazar.districtId)} → {getUpazillaName(bazar.upazillaId)}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {bazar.latitude.toFixed(4)}, {bazar.longitude.toFixed(4)}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {bazar.address}
                        </Typography>
                      </TableCell>
                      <TableCell align="center">{bazar.totalStores}</TableCell>
                      <TableCell align="center">{bazar.totalVendors}</TableCell>
                      <TableCell align="center">৳{(bazar.revenue/1000).toFixed(0)}K</TableCell>
                      <TableCell align="center">
                        <Chip label={bazar.status} color="success" size="small" />
                      </TableCell>
                      <TableCell align="center">
                        <IconButton onClick={(e) => handleActionMenuOpen(e, bazar, 'bazar')}>
                          <MoreVertIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        );

      default:
        return null;
    }
  };

  const renderAddDialog = () => {
    const titles = {
      district: 'নতুন জেলা যোগ করুন',
      upazilla: 'নতুন উপজেলা যোগ করুন',
      bazar: 'নতুন বাজার যোগ করুন'
    };

    return (
      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
        <DialogTitle sx={{ bgcolor: 'primary.main', color: 'white' }}>
          {titles[dialogType]}
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Grid container spacing={3}>
            {/* Common fields for all types */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label={`${dialogType === 'district' ? 'জেলার' : dialogType === 'upazilla' ? 'উপজেলার' : 'বাজারের'} নাম (বাংলা)`}
                variant="outlined"
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label={`${dialogType === 'district' ? 'জেলার' : dialogType === 'upazilla' ? 'উপজেলার' : 'বাজারের'} নাম (ইংরেজি)`}
                variant="outlined"
                required
              />
            </Grid>

            {/* Parent selection for upazilla and bazar */}
            {dialogType === 'upazilla' && (
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>জেলা নির্বাচন করুন</InputLabel>
                  <Select
                    value={selectedDistrict}
                    onChange={(e) => setSelectedDistrict(e.target.value)}
                    label="জেলা নির্বাচন করুন"
                  >
                    {locations.districts.map((district) => (
                      <MenuItem key={district.id} value={district.id}>
                        {district.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}

            {dialogType === 'bazar' && (
              <>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel>জেলা নির্বাচন করুন</InputLabel>
                    <Select
                      value={selectedDistrict}
                      onChange={(e) => setSelectedDistrict(e.target.value)}
                      label="জেলা নির্বাচন করুন"
                    >
                      {locations.districts.map((district) => (
                        <MenuItem key={district.id} value={district.id}>
                          {district.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel>উপজেলা নির্বাচন করুন</InputLabel>
                    <Select
                      value={selectedUpazilla}
                      onChange={(e) => setSelectedUpazilla(e.target.value)}
                      label="উপজেলা নির্বাচন করুন"
                      disabled={!selectedDistrict}
                    >
                      {locations.upazillas
                        .filter(upazilla => upazilla.districtId == selectedDistrict)
                        .map((upazilla) => (
                          <MenuItem key={upazilla.id} value={upazilla.id}>
                            {upazilla.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
              </>
            )}

            {/* Location coordinates */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="অক্ষাংশ (Latitude)"
                variant="outlined"
                type="number"
                step="any"
                placeholder="23.8103"
                required
                InputProps={{
                  endAdornment: (
                    <Tooltip title="বর্তমান অবস্থান পেতে ক্লিক করুন">
                      <IconButton size="small">
                        <MyLocationIcon />
                      </IconButton>
                    </Tooltip>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="দ্রাঘিমাংশ (Longitude)"
                variant="outlined"
                type="number"
                step="any"
                placeholder="90.4125"
                required
              />
            </Grid>

            {/* Specific fields based on type */}
            {dialogType === 'district' && (
              <>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="জনসংখ্যা"
                    variant="outlined"
                    type="number"
                    placeholder="9000000"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="এলাকা (বর্গ কিলোমিটার)"
                    variant="outlined"
                    type="number"
                    step="any"
                    placeholder="1463.60"
                  />
                </Grid>
              </>
            )}

            {dialogType === 'upazilla' && (
              <>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="জনসংখ্যা"
                    variant="outlined"
                    type="number"
                    placeholder="350000"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="এলাকা (বর্গ কিলোমিটার)"
                    variant="outlined"
                    type="number"
                    step="any"
                    placeholder="8.3"
                  />
                </Grid>
              </>
            )}

            {dialogType === 'bazar' && (
              <>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="সম্পূর্ণ ঠিকানা"
                    variant="outlined"
                    multiline
                    rows={2}
                    placeholder="ধানমন্ডি রোড ২৭, ঢাকা"
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="প্রতিষ্ঠিত সাল"
                    variant="outlined"
                    type="number"
                    placeholder="1995"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="এলাকা (একর)"
                    variant="outlined"
                    type="number"
                    step="any"
                    placeholder="2.5"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="পরিচালনার সময়"
                    variant="outlined"
                    placeholder="৬:০০ - ২২:০০"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="প্রাথমিক দোকানের সংখ্যা"
                    variant="outlined"
                    type="number"
                    placeholder="45"
                  />
                </Grid>
              </>
            )}

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="বিবরণ/মন্তব্য"
                variant="outlined"
                multiline
                rows={3}
                placeholder="অতিরিক্ত তথ্য বা মন্তব্য..."
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <Button onClick={handleCloseDialog} variant="outlined">
            বাতিল করুন
          </Button>
          <Button 
            onClick={handleCloseDialog} 
            variant="contained"
            sx={{
              background: 'linear-gradient(45deg, #4e279d 30%, #1275cb 90%)',
            }}
          >
            যোগ করুন
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  return (
    <Box>
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 600, color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
            <MapIcon sx={{ fontSize: 40 }} />
            বাজার ম্যানেজার
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            গ্রামীণবাজারের সম্প্রসারণ এলাকা পরিচালনা - জেলা, উপজেলা এবং বাজার ব্যবস্থাপনা
          </Typography>
        </Box>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => handleAddNew('district')}
          sx={{
            background: 'linear-gradient(45deg, #4e279d 30%, #1275cb 90%)',
            color: 'white',
            px: 3,
            py: 1.5,
            borderRadius: 2,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            '&:hover': {
              background: 'linear-gradient(45deg, #3d1789 30%, #0a5ea8 90%)',
              boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
            }
          }}
        >
          নতুন এলাকা যোগ করুন
        </Button>
      </Box>

      {/* Info Alert */}
      <Alert severity="info" sx={{ mb: 3 }} icon={<LocationOnIcon />}>
        <AlertTitle>বাজার ম্যানেজার সম্পর্কে</AlertTitle>
        এই সিস্টেমের মাধ্যমে গ্রামীণবাজারের নতুন সম্প্রসারণ এলাকা যোগ করুন। প্রথমে জেলা, তারপর উপজেলা এবং সবশেষে 
        নির্দিষ্ট বাজার যোগ করুন। প্রতিটি এলাকার সঠিক অক্ষাংশ ও দ্রাঘিমাংশ প্রদান করুন সেবা প্রদানের জন্য।
      </Alert>

      {/* Navigation Tabs */}
      <Paper sx={{ mb: 3 }}>
        <Tabs 
          value={currentTab} 
          onChange={handleTabChange}
          variant="fullWidth"
          sx={{
            '& .MuiTab-root': {
              fontWeight: 500,
              py: 2,
            }
          }}
        >
          <Tab label="সারসংক্ষেপ" icon={<AnalyticsIcon />} iconPosition="start" />
          <Tab label="জেলাসমূহ" icon={<PublicIcon />} iconPosition="start" />
          <Tab label="উপজেলাসমূহ" icon={<BusinessIcon />} iconPosition="start" />
          <Tab label="বাজারসমূহ" icon={<StoreIcon />} iconPosition="start" />
        </Tabs>
      </Paper>

      {/* Tab Content */}
      <Box sx={{ mt: 3 }}>
        {renderTabContent()}
      </Box>

      {/* Action Menu */}
      <Menu
        anchorEl={actionMenuAnchor}
        open={Boolean(actionMenuAnchor)}
        onClose={handleActionMenuClose}
      >
        <MenuItem onClick={handleActionMenuClose}>
          <VisibilityIcon sx={{ mr: 1, fontSize: 18 }} />
          বিস্তারিত দেখুন
        </MenuItem>
        <MenuItem onClick={handleActionMenuClose}>
          <EditIcon sx={{ mr: 1, fontSize: 18 }} />
          সম্পাদনা করুন
        </MenuItem>
        <MenuItem onClick={handleActionMenuClose}>
          <MapIcon sx={{ mr: 1, fontSize: 18 }} />
          মানচিত্রে দেখুন
        </MenuItem>
        <MenuItem onClick={handleActionMenuClose} sx={{ color: 'error.main' }}>
          <DeleteIcon sx={{ mr: 1, fontSize: 18 }} />
          মুছে ফেলুন
        </MenuItem>
      </Menu>

      {/* Add Dialog */}
      {renderAddDialog()}

      {/* Floating Action Button */}
      <Fab
        color="primary"
        aria-label="add location"
        onClick={() => handleAddNew('bazar')}
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          background: 'linear-gradient(45deg, #4e279d 30%, #1275cb 90%)',
          '&:hover': {
            background: 'linear-gradient(45deg, #3d1789 30%, #0a5ea8 90%)',
          }
        }}
      >
        <AddIcon />
      </Fab>
    </Box>
  );
};

export default BazarManager; 